import { RowCrudStatus } from "../../common/types";
import {
  Report,
  ReportCreateMutationVariables,
  ReportUpdateMutationVariables,
} from "../../../api/graphql";
import { LangStore } from "../../../store";
import { reportTypeDisplayId } from "../../reportType/store/ReportTypeCommonStore";
import { blankToNull } from "../../../common/blankToNull";

export type ReportValuesType = {
  id: string;
  displayId: string;
  version_: string;
  __status__: RowCrudStatus;
  name: string;
  __reportType: string;
  showReportType: { displayId: string; id: string } | null;
  template: string;
  constants: string;
  description: string;
};

export type ReportErrorsType = {
  name?: { message: string; fieldLabel: string };
  reportType?: { message: string; fieldLabel: string };
  template?: { message: string; fieldLabel: string };
  constants?: { message: string; fieldLabel: string };
  description?: { message: string; fieldLabel: string };
};

export function ReportValuesInit(): ReportValuesType {
  return {
    id: "",
    displayId: "",
    version_: "",
    __status__: "empty",
    name: "",
    __reportType: "",
    showReportType: null,
    template: "",
    constants: "",
    description: "",
  };
}

export type ReportType = Report | ReportValuesType;

export function reportDisplayId(
  source: Partial<Report>,
  _langStore: LangStore
) {
  return source.name ?? _langStore.emptyStringSymbol;
}

export function getReportValues(
  source: ReportType,
  _langStore: LangStore,
  _duplicated: boolean = false
): ReportValuesType {
  const entityValues = ReportValuesInit();
  entityValues.id = source.id;
  entityValues.displayId =
    "__status__" in source
      ? source.displayId
      : reportDisplayId(source, _langStore);
  entityValues.version_ = source.version_;
  entityValues.name = source.name;
  entityValues.showReportType =
    "reportType" in source && source.reportType
      ? {
          id: source.reportType.id,
          displayId: reportTypeDisplayId(source.reportType, _langStore),
        }
      : "showReportType" in source && source.showReportType
      ? {
          id: source.showReportType.id,
          displayId: source.showReportType.displayId,
        }
      : null;
  entityValues.__reportType = entityValues.showReportType?.displayId || "";
  entityValues.template = source.template;
  entityValues.constants = source.constants || "";
  entityValues.description = source.description || "";
  if (_duplicated) {
    entityValues.__status__ = "added";
  } else if ("__status__" in source) {
    entityValues.__status__ = source.__status__;
  }
  return entityValues;
}

export function getReportUpdateVariables(
  values: ReportValuesType
): ReportUpdateMutationVariables {
  return {
    id: values.id,
    version_: values.version_,
    name: values.name,
    reportTypeId: values.showReportType?.id || "",
    template: values.template,
    constants: blankToNull(values.constants),
    description: blankToNull(values.description),
  };
}

export function getReportCreateVariables(
  values: ReportValuesType
): ReportCreateMutationVariables {
  return {
    name: values.name,
    reportTypeId: values.showReportType?.id || "",
    template: values.template,
    constants: blankToNull(values.constants),
    description: blankToNull(values.description),
  };
}
